import React, { Component } from 'react'

export default class scrabble extends Component {
    render() {
        return (
         
<svg className={this.props.className} onClick={this.props.onClick} width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" d="M28 56.0898C43.464 56.0898 56 43.5538 56 28.0898C56 12.6259 43.464 0.0898438 28 0.0898438C12.536 0.0898438 0 12.6259 0 28.0898C0 43.5538 12.536 56.0898 28 56.0898Z" fill="#FF9E00"/>
<circle cx="35.2651" cy="21.1753" r="3.83389" stroke="#FF9E00" strokeWidth="1.8"/>
<rect x="31.4273" y="31.1695" width="7.66778" height="7.66778" rx="1.6" stroke="#FF9E00" strokeWidth="1.8"/>
<mask id="path-4-inside-1" fill="white">
<rect x="16.7109" y="16.4414" width="9.46778" height="9.46778" rx="1"/>
</mask>
<rect x="16.7109" y="16.4414" width="9.46778" height="9.46778" rx="1" stroke="#FF9E00" strokeWidth="3.6" stroke-linecap="round" strokeLinejoin="bevel" mask="url(#path-4-inside-1)"/>
<path d="M21.3571 32.2547C21.3702 32.232 21.3828 32.2224 21.3928 32.2169C21.4053 32.21 21.4228 32.2047 21.4437 32.2047C21.4645 32.2047 21.4821 32.21 21.4945 32.2169C21.5046 32.2224 21.5172 32.232 21.5303 32.2547L25.2419 38.6834C25.2551 38.7062 25.257 38.7218 25.2568 38.7333C25.2566 38.7476 25.2524 38.7654 25.2419 38.7834C25.2315 38.8015 25.2182 38.814 25.206 38.8214C25.1961 38.8273 25.1816 38.8334 25.1553 38.8334H17.732C17.7058 38.8334 17.6913 38.8273 17.6814 38.8214C17.6692 38.814 17.6559 38.8015 17.6454 38.7834C17.635 38.7654 17.6308 38.7476 17.6306 38.7333C17.6304 38.7218 17.6323 38.7062 17.6454 38.6834L21.3571 32.2547Z" stroke="#FF9E00" strokeWidth="1.8" stroke-linecap="round" strokeLinejoin="bevel"/>
</svg>

        )
    }
}
